import React, { useState } from "react";
import Grid from '@mui/material/Grid';
import { Outlet } from 'react-router-dom';

const Report = (props) => {
    return (        
        <Grid container>
          <Outlet></Outlet>
        </Grid>        
    )
};

export default Report;